export function buildAppPath(path: string, params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : '';
  return `${path}${query}`;
}

export function navigate(path: string, params?: Record<string, string>) {
  window.location.assign(buildAppPath(path, params));
}
